import { IFrameInfo } from '../main/frameInfo'
import { frameInfo } from '../main/frameInfo-sidecar'

export type ICargoType =
  | 'error'
  | 'water'
  | 'ice'
  | 'steel'
  | 'food'
  | 'power'
  | 'battery'
  | 'hydrogen'

export interface ICargoData {
  idx: number
  type: ICargoType
  frame: IFrameInfo
  buildName: string
  buildDesc: string
}

const defaultData: ICargoData = {
  idx: -1,
  type: 'error',
  frame: frameInfo.fi32(5, 2, 6),
  buildDesc: 'Unknown',
  buildName: 'Unk',
}

export const dataList: ICargoData[] = []
export const dataMapIdx: { [key: number]: ICargoData } = {}
export const dataMapName: { [key: string]: ICargoData } = {}

export function getByType(type: ICargoType) {
  return dataMapName['' + type]
}

export function addCargo(type: ICargoType, data: Partial<ICargoData>) {
  let idx = dataList.length
  let d = Object.assign({}, defaultData, data, {
    idx,
    type,
  })
  Object.freeze(d)
  dataList.push(d)
  dataMapIdx[idx] = d
  dataMapName['' + type] = d
}

export const createData = () => {
  addCargo('error', { frame: frameInfo.fAbi(9, 34) })
  addCargo('water', {
    frame: frameInfo.fAbi(9, 16),
    buildName: 'Water',
    buildDesc: 'Two Hydrogens and an Oxygen',
  })
  addCargo('ice', {
    frame: frameInfo.fAbi(9, 6),
    buildName: 'Ice',
    buildDesc: 'Frozen water',
  })
  addCargo('steel', {
    frame: frameInfo.fAbi(9, 9),
    buildName: 'Steel',
    buildDesc: 'Basic building material',
  })
  addCargo('food', {
    frame: frameInfo.fi32(5, 3, 10),
    buildName: 'Food',
    buildDesc: 'Fixes hunger',
  })
  addCargo('power', {
    frame: frameInfo.fAbi(9, 5),
    buildName: 'Powered Battery',
    buildDesc: 'Battery with a full charge',
  })
  addCargo('battery', {
    frame: frameInfo.fAbi(9, 4),
    buildName: 'Empty Battery',
    buildDesc: 'Battery with no charge',
  })
  addCargo('hydrogen', {
    frame: frameInfo.fi32(5, 4, 11),
    buildName: 'Hydrogen',
    buildDesc: 'highly explosive',
  })
}

export const stackTypes: ICargoType[] = [
  'water',
  'ice',
  'steel',
  'food',
  'power',
  'battery',
  'hydrogen',
]
